<template>
  <div class="com-footer">
    <!--
    <div class="dn-center">
      <div class="com-content-1340">
        <div class="dn-nav">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <router-link :to="{name: 'introduce' }" class="dp-a1">About Us</router-link>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <a class="dp-a1" @click="clickSwitchProduct(1)">Product Center</a>
                </div>
                <div class="dn-bot">
                  <a class="dp-a1" @click="clickSwitchProduct(1)">Wooden Decoration</a>
                  <a class="dp-a1" @click="clickSwitchProduct(2)">Seasonal Decoration</a>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <a class="dp-a1" @click="clickSwitchNewsType(stateNews_getNewsType[0])">Exhibition Center</a>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <router-link :to="{name: 'user' }" class="dp-a1">Download center</router-link>
                </div>
                <div class="dn-bot">
                  <router-link :to="{name: 'feedback' }" class="dp-a1">User feedback</router-link>
                  <router-link :to="{name: 'policy' }" class="dp-a1">Maintenance policy</router-link>
                  <router-link :to="{name: 'network' }" class="dp-a1">Service Network</router-link>
                  <router-link :to="{name: 'find' }" class="dp-a1">How to find us</router-link>
                  <router-link :to="{name: 'distinguish' }" class="dp-a1">How to identify crown tools</router-link>
                  <router-link :to="{name: 'guide' }" class="dp-a1">Tool usage guide</router-link>
                  <router-link :to="{name: 'download' }" class="dp-a1">Download Center</router-link>
                </div>
              </div>
              <div class="swiper-slide slide1">
                <div class="dn-top">
                  <router-link :to="{name: 'contact' }" class="dp-a1">Contact us</router-link>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    -->
    <div class="dn-lower">
      <div class="com-content-1340 com-content">
        <div class="dn-left">
          <div class="dn-list">
            <div class="dp-pai">
              {{ statePerInfor.copyright }}
              <a href="https://beian.miit.gov.cn" target="_blank">{{ statePerInfor.icp }}</a>
            </div>
            <div class="dp-pai">
              Office address：{{ statePerInfor.address }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState(['stateimgBaseURL', 'statePerInfor', 'stateIndex_link', 'stateNews_getNewsType'])
  },
  created() {

  },
  methods: {
    clickSwitchProduct(item) {
      this.$router.push({
        name: 'product',
        params: {
          class_id: item,
          zi_id: 'null',
        }
      })
    },

    clickSwitchNewsType(item) {
      this.$router.push('/news/' + item.id)
    },
  },
}
</script>

<style scoped lang="scss">
.com-footer {
  background: $background1;

  .dn-center {
    padding: 55*$pc-conversion 0 40*$pc-conversion;

    .dn-nav {
      .swiper1 {
        .wrapper1 {
          justify-content: space-between;
        }

        .slide1 {
          width: auto;

          .dn-top {
            font-size: 20px;
            font-weight: 600;

            .dp-a1 {
              color: #727376;
              cursor: pointer;
            }
          }

          .dn-bot {
            font-size: 16px;
            line-height: 30px;
            margin: 10*$pc-conversion 0 0;

            .dp-a1 {
              display: block;
              cursor: pointer;

              &:hover {
                text-decoration: underline;
                color: $color2;
              }
            }
          }
        }
      }
    }

    .dn-share {
      margin: 20*$pc-conversion 0 0 260*$pc-conversion;
      width: 190px;
      height: 40px;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .dp-a1 {
        i {
          font-size: 26px;
        }
      }
    }
  }

  .dn-lower {
    padding: 20*$pc-conversion 0;
    background: $background3;

    .com-content {
      display: flex;
      justify-content: space-between;
    }

    .dn-left {
      .dn-nav {
        display: flex;
        align-items: center;
        font-size: 16px;

        .dp-a1 {
          margin: 0 50*$pc-conversion 0 0;

          &:hover {
            text-decoration: underline;
            color: $color2;
          }
        }
      }

      .dn-list {
        padding: 10*$pc-conversion 0 0;

        .dp-pai {
          margin: 15*$pc-conversion 0 0;

          a {
            &:hover {
              color: $color2;
            }
          }
        }
      }
    }

    .dn-right {
      .dn-list {
        display: flex;

        .dp-pai {
          text-align: center;
          margin: 0 0 0 30*$pc-conversion;

          .dp-img1 {
            width: 95px;
            margin: 0 0 10*$pc-conversion;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .com-footer {
    .dn-center {
      padding: 55*$mobile-conversion 0 40*$mobile-conversion;

      .dn-nav {
        display: none;
      }

      .dn-share {
        margin: 0;
        width: 360*$mobile-conversion;
        height: 60*$mobile-conversion;

        .dp-a1 {
          i {
            font-size: 40*$mobile-conversion;
          }
        }
      }
    }

    .dn-lower {
      padding: 20*$mobile-conversion 0;

      .com-content {
        flex-wrap: wrap;
      }

      .dn-left {
        width: 100%;

        .dn-nav {
          font-size: 26*$mobile-conversion;
          flex-wrap: wrap;

          .dp-a1 {
            margin: 0 50*$mobile-conversion 0 0;
          }
        }

        .dn-list {
          padding: 10*$mobile-conversion 0 0;

          .dp-pai {
            margin: 15*$mobile-conversion 0 0;
          }
        }
      }

      .dn-right {
        width: 100%;
        margin: 30*$mobile-conversion 0 0 0;

        .dn-list {
          justify-content: flex-end;

          .dp-pai {
            margin: 0 0 0 30*$mobile-conversion;

            .dp-img1 {
              width: 110*$mobile-conversion;
              margin: 0 0 10*$mobile-conversion;
            }
          }
        }
      }
    }
  }
}
</style>
